import React from 'react'
import { SecretField } from '../../../../../shared/secret/secret-field'
import { SecretDialog, SecretSection } from '../../../../../shared/secret/secret-dialog'

// A new key's secret (a create, or a rotate's new secret), shown once:
// content returns it only in that answer and keeps a hash. Masked until Show;
// the person copies it and says they've stored it. Escape and the backdrop
// don't close the dialog, so it is never lost by a stray key or click.
//
// The secret lives only in this dialog's props, handed down by the page
// that holds it until onDone, when the page lets go of it: nothing else
// keeps it (no storage, no list row, no later render).
export const ApiKeySecretDialog = ({ keyName, secret, rotated, graceText, onDone }) =>
  <SecretDialog title="Copy your new API key" backdropTestId="api-key-secret-backdrop" onDone={onDone}
    note="This is the only time it is shown. EducationXR keeps only a hash of it, so it can't be shown again.">
    <p className="m-0">
      {rotated ? <>The new secret for <strong>{keyName}</strong>.</> : <>The key <strong>{keyName}</strong> is ready.</>}
      {rotated && graceText ? ` ${graceText}` : ''}
    </p>
    <SecretSection n={1} title="Secret key">
      <SecretField value={secret} noun="API key" testId="api-key-secret" />
    </SecretSection>
    <SecretSection n={2} title="Use it">
      <p className="sw-hint small m-0">Send it in the Authorization header as <code>Bearer</code> followed by the key. Never put it in a URL.</p>
    </SecretSection>
  </SecretDialog>
